<template>
  <bordered-container title='Persoonsgegevens'>
    <table class='confirmation-table confirmation-table-adjust-padding mt-2 mb-2'>
      <tr>
        <td>{{ 'employee.name' | translate }}</td>
        <td>{{ employee.getFullName() }}</td>
      </tr>
      <tr>
        <td>{{ 'employee.gender' | translate }}</td>
        <td>{{ employee.gender | translate }}</td>
      </tr>
      <tr>
        <td>{{ 'employee.date-of-birth' | translate }}</td>
        <td>{{ formatDate(employee.dateOfBirth) }}</td>
      </tr>
      <tr v-if="employee.dateOfDeath">
        <td>{{ 'employee.date-of-death' | translate }}</td>
        <td>{{ formatDate(employee.dateOfDeath) }}</td>
      </tr>
      <tr v-if="isShowingExtras">
        <td>{{ 'employee.social-security-number' | translate }}</td>
        <td v-if="employee.bsn">{{ employee.bsn }}</td>
        <td v-else><p class='value light'>Onbekend</p></td>
      </tr>
      <tr v-if="isShowingExtras">
        <td>{{ 'employee.e-mail' | translate }}</td>
        <td v-if="employee.email" style='word-break: break-all;'>{{ employee.email }}</td>
        <td v-else>
          <p class='value light'>Onbekend</p>
        </td>
      </tr>
      <tr v-if="isShowingExtras">
        <td>{{ 'employee.address' | translate }}</td>
        <td v-if="employee.street || employee.zipCode || employee.houseNumber || employee.country">
          {{ employee.street }} {{ employee.mailbox }} {{ employee.houseNumber}}{{ employee.houseNumberExtension }}
          <br />
          {{ employee.zipCode }} {{ employee.city}}
          <br />
          {{ employee.country }}
        </td>
        <td v-else><p class='value light'>Onbekend</p></td>
      </tr>
      <tr>
        <td></td>
        <td align='right'><p class='value link' @click="navigateToEmployee">Naar Werknemer Details</p></td>
      </tr>
    </table>
  </bordered-container>
</template>

<script>
import _ from 'lodash';
import Helpers from '@/shared/helpers/functions';
import Compositions from '@/views/helpers/compositions';

import BorderedContainer from '@aevitae/aevitaeui/0_atoms/containers/BorderedContainer.vue';

import EmployeesView from '@/views/constants/employees';
import AppNavigation from '@/views/constants/app-navigation';

export default {
  name: 'ReportOfSicknessDetailsEmployee',
  props: {
    employee: Object
  },
  components: {
    BorderedContainer
  },
  computed: {
    isShowingExtras () {
      const policies = Compositions.getPoliciesFromParticipations(
        this.employee.allParticipations, this.$store.getters.policies);

      if (policies && policies.length > 0) {
        return _.some(policies, p => p.productType === 'WIA' || p.categoryType === 'INZETBAAR');
      }
      return false;
    }
  },
  methods: {
    formatDate: (date) => Helpers.Dates.formatDate(date),
    navigateToEmployee () {
      this.$store.dispatch(
        AppNavigation.Actions.Navigate.DO,
        AppNavigation.Views.Employees
      ).then(
        this.$store.dispatch(EmployeesView.Actions.Details.OPEN, this.employee)
      );
    }
  }
};
</script>

<style lang='scss' scoped>

.confirmation-table {
  table-layout: fixed;

  tr {
    td {
      &:first-child {
        width: 20%;
      }
      &:last-child {
        width: 80%;
      }
    }

    &:first-child {
      td {
        border-top: 0;
        padding-top: 0;
      }
    }
    &:last-child {
      td {
        border-bottom: 0;
        padding-bottom: 0;
      }
    }
  }
}
.confirmation-table-adjust-padding {
  td {
    &:first-child {
      padding-left: 14px;
    }
    &:last-child {
      padding-right: 14px;
    }
  }
}

</style>
